import { Injectable, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { map } from 'rxjs/operators';

@Injectable()
export class NotificationCustomerService {
  responseData: any;
  handleError: any;
  private toggleIt: EventEmitter<any> = new EventEmitter();
  toggleSender = this.toggleIt.asObservable();

  private newNotification: EventEmitter<any> = new EventEmitter();
  newNotification$ = this.newNotification.asObservable();

  askToToggle(change: any) {
    this.toggleIt.next(change);
  }
  constructor(private router: Router, private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}

  listNotifications() {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = { 'userId[$exists]': true };
    return this.httpClient.get(`${globals.domain}/core/notifications/list`, updateQueries).pipe(map(res => res as any));
  }

  updateNotification(pick: any) {
    this.newNotification.next(pick);
  }
}